/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M3 3H21M3 21H21"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7 17L9 13M17 17L15 13M9 13L12 7L15 13M9 13C9 13 10 14 12 14C14 14 15 13 15 13"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M3 3H21M3 21H21M7 17L9 13M9 13L12 7L15 13M9 13C9 13 10 14 12 14C14 14 15 13 15 13M15 13L17 17"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M3 3H21M3 21H21M7 17L9 13M9 13L12 7L15 13M9 13C9 13 10 14 12 14C14 14 15 13 15 13M15 13L17 17"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M21 3L14 3M10 3L3 3M21 21H14M10 21H3M7 17L9 13M9 13L12 7L17 17M9 13C9 13 10 14 12 14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M3 3H21M3 21H21M7 17L9 13M9 13L12 7L15 13M9 13C9 13 10 14 12 14C14 14 15 13 15 13M15 13L17 17"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M3 3H21M3 21H21M7 17L9 13M9 13L12 7L15 13M9 13C9 13 10 14 12 14C14 14 15 13 15 13M15 13L17 17"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
